export let Global = {
    /** 是否移动终端 */
    isMobile: true,
    /** 屏幕宽度 */
    windowWidth: 800
}